import script from "./fee_list.vue?vue&type=script&setup=true&lang=ts"
export * from "./fee_list.vue?vue&type=script&setup=true&lang=ts"

import "./fee_list.vue?vue&type=style&index=0&id=7330de80&scoped=true&lang=css"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7330de80"]])

export default __exports__